module.exports = __webpack_public_path__ + "static/img/应用场景3-驾驶员行为监控.2d76c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/应用场景3-驾驶员行为监控.png
// module id = Y/vh
// module chunks = 0